/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, name: NonNullable<unknown> }} Directory_Card_Rating_AriaInputs */

const en_directory_card_rating_aria = /** @type {(inputs: Directory_Card_Rating_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} for ${i?.name}`)
};

const zh_directory_card_rating_aria = /** @type {(inputs: Directory_Card_Rating_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 的${i?.label}`)
};

/**
* | output |
* | --- |
* | "{label} for {name}" |
*
* @param {Directory_Card_Rating_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_rating_aria = /** @type {((inputs: Directory_Card_Rating_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Rating_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_rating_aria(inputs)
	return zh_directory_card_rating_aria(inputs)
});
export { directory_card_rating_aria as "directory.card.rating_aria" }